import {Stack as MantineStack} from '@mantine/core';

/**
 * Vertical flex stack — design-layer pass-through over Mantine `Stack`.
 * @registry Pass-through Mantine Stack; import this instead of @mantine/core outside src/design.
 */
export const Stack = MantineStack;
